export default "__VITE_ASSET__DGNwQR7V__"